export default "__VITE_ASSET__ChSO7kKW__"